import React from 'react'

export default function Footer() {
  return (
    <footer>
         Разработка сайта. ООО «Эдельвейс», 2025 &copy; 
    </footer>
  )
}
